<footer class="footer">
    <div class="container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-12 col-sm-12 text-center">
                &copy; {{"Copyright" | translate}} {{currentYear}}
                 <a href="www.skytechsystems.io" target="_blank">{{"skytechsystems" | translate}}</a> 
                  {{"droits réservés." | translate}}
            </div>
        </div>
    </div>
</footer>
